import React, { useState, useEffect } from 'react';

import * as yup from "yup";
import {
	TextField, FormControl, Box, MenuItem, Typography, Grid, Button, Select
} from '@mui/material';
import { NumericFormat } from "react-number-format";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import CustomPopover from "../../../../src/modules/calculations/components/popovers/customPopover";
import useUserData from "../../../hooks/user/useUserData";
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { LOANS_APPLICATION } from "../locales/namespaces";
import LazyAutocomplete from './lazyAutocomplete';
import { color } from 'framer-motion';

const DynamicFormField = ({ formFields, activeIndex, setFormFields, popoverState, setPopoverState, formErrors, setFormErrors, activeIndexSubItem, totalNumberFieldsRequired, handlePopoverId, viewOnly }) => {
	const { language } = useUserData()
	const { t } = useTranslation(LOANS_APPLICATION);
	const currentGroup = activeIndexSubItem !== undefined
		? formFields[activeIndex]?.questions?.subgroups?.[activeIndexSubItem]
		: formFields[activeIndex]?.questions;
	const currentQuestions = currentGroup?.questions || [];
	const [localQuestions, setLocalQuestions] = useState([]);



	useEffect(() => {
		if (currentQuestions?.length > 0 && JSON.stringify(currentQuestions) !== JSON.stringify(localQuestions)) {
			setLocalQuestions(currentQuestions);
		}
	}, [currentQuestions]);

	const handleChange = (fieldIndex, newValue) => {
		setLocalQuestions(prev => {
			const copy = [...prev];
			copy[fieldIndex] = {
				...copy[fieldIndex],
				Value: newValue
			};
			return copy;
		});
	};

	const handleNext = (index) => {
		let nextPopover = localQuestions.length > index + 1 ?  localQuestions[index+1].DescriptionEL : localQuestions[0].DescriptionEL
		setPopoverState({[nextPopover+'']: [nextPopover+'']})

	}


	const handleOnBlur = (fieldIndex, newValue, isCustomValue = false) => {
		const updated = [...formFields];
		const current = updated[activeIndex];
		let isDifferentValue = false
	
		if (current.questions.subgroups?.length > 0) {
			const field = current.questions.subgroups[activeIndexSubItem].questions[fieldIndex];
			if (isCustomValue) {
				isDifferentValue = newValue !== field?.CustomValue
				current.questions.subgroups[activeIndexSubItem].questions[fieldIndex] = {
					...field,
					Value: '',
					CustomValue: newValue
				};
			} else {
				isDifferentValue = newValue !== field?.Value
				current.questions.subgroups[activeIndexSubItem].questions[fieldIndex] = {
					...field,
					Value: newValue,
					CustomValue: field.CustomValue // Keep CustomValue when setting Value
				};
			}
		} else {
			const field = current.questions.questions[fieldIndex];
			if (isCustomValue) {
				isDifferentValue = newValue !== field?.CustomValue
				current.questions.questions[fieldIndex] = {
					...field,
					Value: '',
					CustomValue: newValue
				};
			} else {
				isDifferentValue = newValue !== field?.Value
				current.questions.questions[fieldIndex] = {
					...field,
					Value: newValue,
					CustomValue: field.CustomValue // Keep CustomValue when setting Value
				};
			}
		}
	
		setFormFields(updated, isDifferentValue);

	};

	const renderPopover = (field, ind) => {
		if (!field.popover && !field.DescriptionEL) return null;
		return (
			<Box className="label-popover">
				<CustomPopover
					className={'color-default p-xsfs'}
					id={field.QuestionId}
					title={(language === 'en' ? field.DescriptionEN : field.DescriptionEL)}
					content={field?.popover?.content ? field.popover.content : (language === 'en' ? field.InfoEN : field.InfoEL)}
					isOpen={popoverState[field.DescriptionEL] || false}
					setIsOpen={(val) => setPopoverState(prev => ({ ...prev, [field.DescriptionEL]: val })) }
					isLtv={false}
					handleNext={()=>{handleNext(ind)}}
				/>
			</Box>
		);
	};

	return (
		<Box className="loans-application-form">
			<Typography className='color-defaul p-xl' sx={{ marginBottom: {xs:'8px',sm:'8px',md:'16px',}, fontSize:{xs:'18px !important',sm:'22px !important'}  }} >
				{(language === 'en' ? formFields[activeIndex]?.questions.DescriptionEN : formFields[activeIndex]?.questions.DescriptionEL)}
			</Typography>
			<Box sx={{ backgroundColor: 'white', border: '0.6px solid #DAE0F0', borderRadius: '12px', minHeight: 'calc(100vh - 300px)' }}>
				{(currentGroup?.DescriptionEL && formFields[activeIndex]?.questions?.subgroups.length > 0) && (
					<Typography className='color-defaul title-sm' sx={{ borderBottom: '0.6px solid #DAE0F0', padding: {xs: '16px 16px', sm: '16px 16px', md:'20px 24px' } }}>
						{(language === 'en' ? currentGroup?.DescriptionEN : currentGroup?.DescriptionEL)}
					</Typography>
				)}
				<Box sx={{ padding: {xs: '16px 16px', sm: '16px 16px', md:'20px 24px'} , 'label': { display: 'block', fontSize: '12px', color: '#485476' } }}>
					<Grid container spacing={2}>

						{localQuestions?.map((field, index) => {
							
							const isFieldDisabled = viewOnly || field.readonly;
							const commonProps = {
								name: (language === 'en' ? field.DescriptionEN : field.DescriptionEL),
								value: field.Value || '',
								size: 'small',
								fullWidth: true,
								error: !!formErrors?.[field.QuestionId + '_' + field.GroupId+ '_' + field.GroupRepeatNum] || (!!field.CustomEntry && !!formErrors?.[field.QuestionId + '_' + field.GroupId+ '_' + field.GroupRepeatNum + '_custom']),
								helperText: formErrors?.[field.QuestionId + '_' + field.GroupId+ '_' + field.GroupRepeatNum] || (field.CustomEntry && formErrors?.[field.QuestionId + '_' + field.GroupId+ '_' + field.GroupRepeatNum + '_custom']),
								required: field.required,
									disabled: isFieldDisabled,
								onBlur: (e) => {
									handleOnBlur(index, e.target.value);
								}
							};
							const commonPropsAutocomplete = {
								name: (language === 'en' ? field.DescriptionEN : field.DescriptionEL),
								size: 'small',
								fullWidth: true,
								error: !!formErrors?.[field.QuestionId + '_' + field.GroupId+ '_' + field.GroupRepeatNum],
								helperText: formErrors?.[field.QuestionId + '_' + field.GroupId+ '_' + field.GroupRepeatNum],
								disabled: isFieldDisabled,
							};
							switch (field.Type) {
								case 'email':
								case 'text':
									return (
										<Grid item xs={12} md={6} key={(language === 'en' ? field.DescriptionEN : field.DescriptionEL) + index}>
											<FormControl variant="standard" fullWidth sx={{ marginBottom:{xs:'0', sm:'8px', md:'8px'} }}>
												{renderPopover(field, index)}
												<TextField
													{...commonProps}
													onChange={e => handleChange(index, e.target.value)}
													inputProps={{ maxLength: 100 }}
												/>
											</FormControl>
										</Grid>
									);

								case 'number':
								case 'integer':
								case 'decimal':
									return (
										<Grid item xs={12} md={6} key={field.DescriptionEL + index}>
											<FormControl variant="standard" fullWidth sx={{ marginBottom:{xs:'0', sm:'8px', md:'8px'} }}>
												{renderPopover(field, index)}
												<NumericFormat
													{...commonProps}
													onChange={e => handleChange(index, e.target.value)}

													decimalScale={2}
													customInput={TextField}

												/>
											</FormControl>
										</Grid>
									);


								case 'list':
									return (
										<Grid item xs={12} md={6} key={field?.QuestionId + `field-list-${index}`}>
											<FormControl fullWidth sx={{ marginBottom:{xs:'0', sm:'8px', md:'8px'} }}>
												{renderPopover(field, index)}
												<LazyAutocomplete field={field} language={language} index={index} commonProps={commonPropsAutocomplete} handleOnBlur={handleOnBlur} />
											</FormControl>
										</Grid>
									);

								case 'simple list':
									return (
										<Grid item xs={12} md={6} key={field?.QuestionId + `field-simple-select-${index}`}>
											<FormControl fullWidth sx={{ marginBottom:{xs:'0', sm:'8px', md:'8px'} }}>
												{renderPopover(field, index)}
												<Select
													className='simple-list'
													{...commonProps}
													value={field.Value || ''}
													onChange={e => {
														handleChange(index, e.target.value);
														handleOnBlur(index, e.target.value);
													}}
												>
													{field.Options?.map((option) => (
														<MenuItem key={option.OptionId} value={option.OptionId}>
															{language === 'en' ? option.DescriptionEN : option.DescriptionEL}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</Grid>
									);

								case 'date':
									return (
										<Grid item xs={12} md={6} key={field.DescriptionEL + index}>
											<FormControl fullWidth sx={{ marginBottom:{xs:'0', sm:'8px', md:'8px'} }}>
												{renderPopover(field, index)}
												<LocalizationProvider dateAdapter={AdapterMoment}>
												<DatePicker
													{...commonProps}
													sx={{
														'.MuiInputBase-root': { padding: '4px  0' },
														'.MuiIconButton-edgeEnd': { marginRight: '-4px' }
													}}
													views={['year', 'month', 'day']}
													openTo="year"
													value={
														field.Value
															? moment(field.Value, 'DD/MM/YYYY', true).isValid()
															? moment(field.Value, 'DD/MM/YYYY')
															: moment(field.Value)
															: null
													}
													inputFormat="DD/MM/YYYY"
													slotProps={{
														textField: {
															size: 'small',
															error: !!formErrors?.[field.QuestionId + '_' + field.GroupId+ '_' + field.GroupRepeatNum],
															helperText: formErrors?.[field.QuestionId + '_' + field.GroupId+ '_' + field.GroupRepeatNum],
															onBlur: (e) => {
																const inputValue = e.target.value;
																const parsedDate = moment(inputValue, 'DD/MM/YYYY', true);
																handleOnBlur(index, parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : '');
															}
														}
													}}
													onAccept={(date) => {

														handleOnBlur(index, date ? moment(date).format('DD/MM/YYYY') : '');
													}}
													/>

												</LocalizationProvider>
											</FormControl>
										</Grid>
									);

								default:
									return null;
							}
						})}
					</Grid>
				</Box>
			</Box>
		</Box>
	);
};

export default DynamicFormField;